<template>
  <div class="videoCover">
    <el-upload
      v-if="!value"
      action=""
      :auto-upload="false"
      accept="image/*"
      :limit="1"
      :show-file-list="false"
      :on-change="onChange"
    >
      <div class="Upload">
        <div class="el-icon-picture icon"></div>
        <div class="title">选择封面</div>
      </div>
    </el-upload>

    <div v-else class="videoBoxMain">
      <videoBox :imgUrl="value" hideIcon/>
      <img src="@/assets/image/close3.webp" class="close" @click="onClear" />
    </div>
    <transition name="el-zoom-in-bottom">
      <div class="progress" v-show="progressPercent > 0">
        <el-progress :show-text="false" :percentage="progressPercent"></el-progress>
      </div>
    </transition>
  </div>
</template>

<script>
import videoBox from "@/views/Information/components/videoBox.vue";
import uploadFile from "@/utils/oss.js"; // 引入oss.js文件
export default {
  components: { videoBox },
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      progressPercent: 0,
    };
  },
  created() {},
  computed: {},
  methods: {
    onInput(value) {
      this.$emit("input", value);
    },
    onProgress(res) {
      console.log(res);
      if (res) {
        this.progressPercent = res;
      }
    },
    async onChange(file) {
      try {
        this.progressPercent = 5;
        const { data } = await this.$api.getFileSts();
        const response = await uploadFile(
          file.raw,
          data,
          "znsign/avatar",
          this.onProgress
        );
        if (response.res.status !== 200) {
          this.$message({
            type: "error",
            message: "上传失败，请联系管理员",
          });
          return;
        }
        this.onInput(this.$oss + response.name);
      } finally {
        setTimeout(() => {
          this.progressPercent = 0;
        },500)
      }
    },
    onClear() {
      this.onInput("");
    },
  },
};
</script>

<style scoped lang="scss">
.videoCover {
  margin-top: 4px;
  width: 200px;
  height: 112px;
  border-radius: 6px;
  overflow: hidden;
  .Upload {
    width: 200px;
    height: 112px;
    border-radius: 6px;

    /* 自动布局 */
    display: flex;

    background: rgba($color: #000000, $alpha: 0.5);
    color: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .icon {
      font-size: 30px;
    }
    .title {
      font-size: 14px;
      font-weight: 350;
    }
  }
  .videoBoxMain {
    position: relative;
    z-index: 1;
    .close {
      position: absolute;
      width: 16px;
      height: 16px;
      left: calc(200px - 16px - 4px);
      top: 4px;
      cursor: pointer;
    }
  }
  .progress {
    position: absolute;
    bottom: 0;
    width: 100%;
    z-index: 3;
    width: 200px;
  }
}
</style>
